import type { DynamicHelpConfig } from '../../default/cms/dynamicHelp.types';

export const dynamicHelp: DynamicHelpConfig = {
  labelMessageKey: 'forms.contact.dynamicSubject.howCanWeHelp',
  items: [
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.order',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.orderCreate',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.orderCreate',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.orderChange',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.orderChange',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.orderCancel',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.orderCancel',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.orderStatus',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.orderStatus',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.orderProductInfo',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.orderProductInfo',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.delivery',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.deliveryStatus',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.deliveryStatus',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.deliveryIncomplete',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.deliveryIncomplete',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.deliveryWrongItem',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.deliveryWrongItem',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.deliveryDefectiveItem',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.deliveryDefectiveItem',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.deliveryTransportDamage',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.deliveryTransportDamage',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.deliveryService',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.deliveryService',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.loyalty',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.loyaltyVorteilsclub',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.loyaltyVorteilsclub',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.loyaltyJoeBonusclub',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.loyaltyJoeBonusclub',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.promotionNotRedeemable',
      messageKeyAnswer: 'forms.contact.dynamicAnswer.promotionNotRedeemable',
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.payment',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.paymentMethods',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.paymentMethods',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.paymentFlexInstallment',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.paymentFlexInstallment',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.paymentFlexPause',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.paymentFlexPause',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.paymentFlexProtection',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.paymentFlexProtection',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.account',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.accountpayments',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.accountpayments',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.accountPersonalDataChange',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.accountPersonalDataChange',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.accountBookings',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.accountBookings',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.return',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.returnDeadlines',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.returnDeadlines',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.returnStatus',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.returnStatus',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.returnCredit',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.returnCredit',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.returnLabelMissing',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.returnLabelMissing',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.returnFreightItem',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.returnFreightItem',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.returnExchange',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.returnExchange',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.claimWarranty',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.claimWarrantyGuarantee',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.claimWarrantyGuarantee',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.claimTech',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.claimTech',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.claimFurniture',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.claimFurniture',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.claimFashion',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.claimFashion',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.claimRepairStatus',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.claimRepairStatus',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.claimSparePartStatus',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.claimSparePartStatus',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.other',
      subHelpTopics: [
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.otherNewsletter',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.otherNewsletter',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.otherMediaRequest',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.otherMediaRequest',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.otherDataUsageWithdrawal',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.otherDataUsageWithdrawal',
        },
        {
          messageKeySelectOption: 'forms.contact.dynamicSubject.otherShopFeedback',
          messageKeyAnswer: 'forms.contact.dynamicAnswer.otherShopFeedback',
        },
      ],
    },
    {
      messageKeySelectOption: 'forms.contact.dynamicSubject.accessibilityReport',
      messageKeyAnswer: 'forms.contact.dynamicAnswer.accessibilityReport',
    },
  ],
};
